module.exports = __webpack_public_path__ + "static/img/bg.283707d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/14/bg.png
// module id = gcQ4
// module chunks = 2